import { render, staticRenderFns } from "./SellBusinessAdd.vue?vue&type=template&id=37b0a6c0&scoped=true&"
import script from "./SellBusinessAdd.vue?vue&type=script&lang=js&"
export * from "./SellBusinessAdd.vue?vue&type=script&lang=js&"
import style0 from "./SellBusinessAdd.vue?vue&type=style&index=0&id=37b0a6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b0a6c0",
  null
  
)

export default component.exports